import { render, staticRenderFns } from "./FixCode.vue?vue&type=template&id=f1dabc74&scoped=true&"
import script from "./FixCode.vue?vue&type=script&lang=js&"
export * from "./FixCode.vue?vue&type=script&lang=js&"
import style0 from "./FixCode.vue?vue&type=style&index=0&id=f1dabc74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1dabc74",
  null
  
)

export default component.exports